/** Upper bound on sorted columns in the context snapshot — no real grid sorts by more than a few. */
export const ASSISTANT_GRID_SORT_MAX_ITEMS = 50;
